import { SxProps } from '@mui/material'
import { FONT_WEIGHTS } from '@/styles'

export interface SummaryCardActionsStyles {
  buttonWrapper: SxProps
  button: SxProps
  buttonText: SxProps
}

export const summaryCardActionsStyles: SummaryCardActionsStyles = {
  buttonWrapper: { gap: 2, display: 'flex' },
  button: { px: 0, width: '50%' },
  buttonText: { typography: 'textSm', fontWeight: FONT_WEIGHTS.SEMI_BOLD },
}
